import graphqlClient from '~/graphql/graphqlClient';
import {
  MutationSetPortalLevelToCurrentDepthArgs,
  SetPortalLevelToCurrentDepthResult,
} from 'dt-common/generated/graphql-types';

const mutation = `
mutation SetPortalLevelToCurrentDepth($playerId: String!, $game_submode: String!) {
  setPortalLevelToCurrentDepth(playerId: $playerId, game_submode: $game_submode) {
    game_submode
    new_portal_level
    caverns_data
  }
}
`;

export default async function mutationSetPortalLevelToCurrentDepth(
  args: MutationSetPortalLevelToCurrentDepthArgs
) {
  return await graphqlClient.request<SetPortalLevelToCurrentDepthResult>(
    'setPortalLevelToCurrentDepth',
    mutation,
    args
  );
}

